import { LookupConfiguration } from "common/form/types";

export const isUserDefinedValid = (value: LookupConfiguration) =>
  value?.type === "userDefined" &&
  !!value.targetEntity &&
  value.mappedFields?.length > 0 &&
  value.mappedFields.every(
    (field) => field.columnName && field.targetColumnName,
  );
